module.exports = __webpack_public_path__ + "img/logo-white-bg.3310336a.svg";